import React from "react"

import { Container, Item, Logo } from "./styles"

export default function Header() {
  return (
    <Container>
      <Item>
        <Logo type="itau" />
      </Item>
      <Item>
        <Logo type="portofaz" />
      </Item>
    </Container>
  )
}
